import { RELEASE_STATUSES } from '@chukua/common';
import { DatePicker, Form, Input, Select, Switch } from 'antd';
import { RELEASE_STATUS_LABELS } from '../policies/release-status-labels';
import { ZoneSearchSelect } from '../../../../zones/public/ZoneSearchSelect';

const PICKUP_ZONE_KINDS = ['port', 'icd', 'cfs'];
const DEPOT_ZONE_KINDS = ['depot'];

/** Every field of the container details form, kept out of ContainerJobDetailsForm to stay under the line limit — same split as JobIntakeDetailFields. */
export function ContainerDetailFields() {
  return (
    <>
      <div className="grid grid-cols-2 gap-3">
        <Form.Item name="shippingLine" label="Shipping line">
          <Input />
        </Form.Item>
        <Form.Item name="vessel" label="Vessel">
          <Input />
        </Form.Item>
      </div>
      <div className="grid grid-cols-2 gap-3">
        <Form.Item name="billOfLading" label="Bill of lading">
          <Input />
        </Form.Item>
        <Form.Item name="releaseOrder" label="Release order">
          <Input />
        </Form.Item>
      </div>
      <div className="grid grid-cols-2 gap-3">
        <Form.Item name="releaseStatus" label="Release status">
          <Select allowClear options={RELEASE_STATUSES.map((status) => ({ value: status, label: RELEASE_STATUS_LABELS[status] }))} />
        </Form.Item>
        <Form.Item name="bondReference" label="Bond reference">
          <Input />
        </Form.Item>
      </div>
      <div className="grid grid-cols-2 gap-3">
        <Form.Item name="pickupZoneCode" label="Pickup — port, ICD or CFS">
          <ZoneSearchSelect kinds={PICKUP_ZONE_KINDS} />
        </Form.Item>
        <Form.Item name="emptyReturnDepotZoneCode" label="Empty-return depot" rules={[{ required: true, message: 'Select the empty-return depot' }]}>
          <ZoneSearchSelect kinds={DEPOT_ZONE_KINDS} />
        </Form.Item>
      </div>
      <Form.Item name="emptyReturnFreeDaysDeadline" label="Empty-return free-days deadline" rules={[{ required: true, message: 'Set the free-days deadline' }]}>
        <DatePicker className="w-full" />
      </Form.Item>
      <div className="grid grid-cols-2 gap-3">
        <Form.Item name="isTransit" label="Transit cargo" valuePropName="checked">
          <Switch />
        </Form.Item>
        <Form.Item name="isHazardous" label="Hazardous cargo" valuePropName="checked">
          <Switch />
        </Form.Item>
      </div>
    </>
  );
}
